import { useParams } from 'react-router-dom';
import useEventIdStorage from './useEventIdStorage';

const useEventId = () => {
  const { eventId: eventIdFromParams } = useParams();
  const { getEventId } = useEventIdStorage();

  // rota tem prioridade; se não tiver, pega do storage
  return eventIdFromParams || getEventId() || null;
}

export default useEventId;